/**
 * Persistent guest session id (`mf_gsid`).
 *
 * A stable per-browser UUID written on first use and stored in localStorage.
 * It is NEVER cleared on authentication, so it bridges a guest's pre-auth
 * activity to their account. Analytics already stamp it on every EventLog as
 * `meta.guestSessionId`; the upload + auth-claim flows reuse the same id so a
 * layout uploaded by a guest can be attributed to them even if they close the
 * page before processing finishes and sign in later.
 *
 * Dependency-free on purpose so low-level services (e.g. the upload service)
 * can import it without pulling in React/analytics modules.
 *
 * Key: mf_gsid  (magic furnish guest session id)
 */
const GUEST_SESSION_STORAGE_KEY = 'mf_gsid';

export function getGuestSessionId() {
  try {
    let id = localStorage.getItem(GUEST_SESSION_STORAGE_KEY);
    if (!id) {
      // crypto.randomUUID() requires HTTPS or localhost (Chrome 92+, Safari 15.4+, FF 95+).
      // Fallback covers HTTP contexts and older iOS WebViews.
      id =
        typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID()
          : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
              const r = (Math.random() * 16) | 0;
              return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
            });
      localStorage.setItem(GUEST_SESSION_STORAGE_KEY, id);
    }
    return id;
  } catch {
    // localStorage unavailable (private browsing quirks, sandboxed iframe, SSR)
    return null;
  }
}

export { GUEST_SESSION_STORAGE_KEY };
